var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "justify-center", attrs: { id: "nbe" } },
    [
      _c("ehr-navigation", { attrs: { "active-item": "nbe" } }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-sm-11" },
            [
              _c(
                "section-card",
                {
                  attrs: {
                    "card-icon": "books",
                    "card-title": "Nuttige beroepservaring",
                    isLoading: false
                  }
                },
                [
                  _c(
                    "section",
                    { staticClass: "beroepservaringen" },
                    [
                      _vm.isAddingNewBeroepservaring
                        ? _c(
                            "div",
                            { staticClass: "mb-2 p-2" },
                            [
                              _c("h5", { staticClass: "mb-3" }, [
                                _vm._v(
                                  "\n                Uw aanvraag geldelijke anciënniteit\n              "
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.progressLoaded
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "container text-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "spinner-border text-primary text-center",
                                            attrs: { role: "status" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [_vm._v("Loading...")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.aanvraagNotFound
                        ? [
                            _c(
                              "info-alert",
                              { attrs: { "color-class": "primary" } },
                              [
                                _vm._v(
                                  "U heeft op dit moment geen aanvraag nuttige beroepservaring.\n                Indien u vragen heeft, gelieve HR te contacteren."
                                )
                              ]
                            )
                          ]
                        : _vm.aanvraagIsCancelled
                        ? [
                            _c(
                              "info-alert",
                              { attrs: { "color-class": "primary" } },
                              [
                                _vm._v(
                                  "U heeft de aanvraag nuttige beroepservaring\n                geannuleerd."
                                )
                              ]
                            )
                          ]
                        : !_vm.hasDoneAanvraag
                        ? [
                            _c(
                              "ehr-stepper",
                              {
                                attrs: {
                                  steps: _vm.steps,
                                  canContinue: _vm.canContinueStepper,
                                  isFormChanged: true,
                                  showCancel: !_vm.canContinueStepper,
                                  resumeStep: this.activeStep
                                },
                                on: {
                                  "active-step-changed": _vm.updateActiveStep,
                                  "cancel-stepper": _vm.cancelStepper,
                                  "stepper-finished": _vm.submitNbeRequest
                                }
                              },
                              [
                                _c("ga-form", {
                                  staticClass: "mt-4 container",
                                  attrs: {
                                    "aanvraag-ga":
                                      _vm.aanvraagGeldigeAncienniteit,
                                    "active-step": _vm.activeStep,
                                    "on-cancelled-change": ""
                                  },
                                  on: {
                                    "can-continue-changed":
                                      _vm.updateCanContinue,
                                    "on-save-nbe-request-progress":
                                      _vm.saveNbeRequestProgressToDB,
                                    "validation-change":
                                      _vm.updateValidationState
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm.progressLoaded && _vm.isAanvraagBehandeld
                        ? [
                            _vm.isAanvraagBehandeld
                              ? _c(
                                  "info-alert",
                                  { attrs: { "color-class": "primary" } },
                                  [
                                    _vm._v(
                                      "Uw aanvraag is behandeld. Hieronder ziet u het overzicht van\n                de behandeling van uw aanvraag."
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("aanvraag-ga-overzicht", {
                              attrs: {
                                "aanvraag-ga": _vm.aanvraagGeldigeAncienniteit
                              }
                            })
                          ]
                        : _vm.aanvraagNeedsInfo
                        ? [
                            _vm.aanvraagNeedsInfo
                              ? _c(
                                  "info-alert",
                                  { attrs: { "color-class": "warning" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Uw aanvraag heeft meer info nodig. Gelieve uw aanvraag aan\n                  te vullen."
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ehr-stepper",
                              {
                                attrs: {
                                  steps: _vm.steps,
                                  canContinue: _vm.canContinueStepper,
                                  isFormChanged: true,
                                  showCancel: !_vm.canContinueStepper,
                                  resumeStep: this.activeStep
                                },
                                on: {
                                  "active-step-changed": _vm.updateActiveStep,
                                  "cancel-stepper": _vm.cancelStepper,
                                  "stepper-finished": _vm.submitNbeRequest
                                }
                              },
                              [
                                _c("ga-form", {
                                  staticClass: "mt-4 container",
                                  attrs: {
                                    "aanvraag-ga":
                                      _vm.aanvraagGeldigeAncienniteit,
                                    "active-step": _vm.activeStep,
                                    "on-cancelled-change": ""
                                  },
                                  on: {
                                    "can-continue-changed":
                                      _vm.updateCanContinue,
                                    "on-save-nbe-request-progress":
                                      _vm.saveNbeRequestProgressToDB,
                                    "validation-change":
                                      _vm.updateValidationState
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm.hasDoneAanvraag &&
                          _vm.progressLoaded &&
                          !_vm.isAanvraagBehandeld
                        ? [
                            _c(
                              "info-alert",
                              { attrs: { "color-class": "primary" } },
                              [
                                _vm._v(
                                  "\n                U deed reeds een aanvraag voor nuttige beroepservaring.\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("aanvraag-ga-overzicht", {
                              attrs: {
                                "aanvraag-ga": _vm.aanvraagGeldigeAncienniteit
                              }
                            }),
                            _vm._v(" "),
                            _c("hr")
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }